import PaymentsApi from '../../../../api/payments-api';
import actionTypes from '../constants/action-types';
import constants from '../../../../common/constants';
import { handleHttpInProgress } from '../../../shared/http-in-progress/actions/http-in-progress-actions';
import { toggleInfoModal } from '../../../shared/info-modal/actions/info-modal-actions';

export const getUserPaymentMethods = (status, provider, type) => {
  return async dispatch => {
    dispatch(handleHttpInProgress(true));
    try {
      const response = await PaymentsApi.getUserPaymentMethods(status, provider, type);
      const data = response && response.data;
      dispatch(handleSuccessGetPaymentMethods(data));
      dispatch(handleHttpInProgress(false));
    } catch (error) {
      dispatch(handleHttpInProgress(false));
    }
  };
};

export const getPaymentMethodTypes = active => {
  return async dispatch => {
    try {
      const response = await PaymentsApi.getPaymentMethodTypes(active);
      const data = response && response.data;
      dispatch(handleSuccessGetPaymentMethodTypes(data));
    } catch (error) {}
  };
};

export const saveUserPaymentMethod = data => {
  return async dispatch => {
    dispatch(handleHttpInProgress(true));
    try {
      /* eslint-disable */
      const response = await PaymentsApi.saveUserPaymentMethod(data);
      /* eslint-enable */
      const method = data.payment_method_type_id === constants.payment_method_types.bank.id ? 'bank account' : 'payment method';
      dispatch(toggleAddPaymentMethodModal(false));
      dispatch(
        toggleInfoModal(true, constants.info_modal_types.success.value, 'PAYMENT_METHOD.SUCCESS_SAVE_METHOD', {
          method,
        })
      );
      dispatch(getUserPaymentMethods());
    } catch (error) {
      dispatch(handleHttpInProgress(false));
    }
  };
};

export const handleSuccessGetPaymentMethods = data => {
  return {
    type: actionTypes.HANDLE_SUCCESS_GET_PAYMENT_METHODS,
    data,
  };
};

export const togglePaymentMethodModal = show => {
  return {
    type: actionTypes.TOGGLE_PAYMENT_METHOD_MODAL,
    data: show,
  };
};

export const handleSuccessGetPaymentMethodTypes = data => {
  return {
    type: actionTypes.HANDLE_SUCCESS_GET_PAYMENT_METHOD_TYPES,
    data,
  };
};

export const toggleAddPaymentMethodModal = show => {
  return {
    type: actionTypes.TOGGLE_ADD_PAYMENT_METHOD_MODAL,
    data: show,
  };
};

export const handleSelectedPaymentMethodType = paymentMethod => {
  return {
    type: actionTypes.HANDLE_SELECTED_PAYMENT_METHOD_TYPE,
    data: paymentMethod,
  };
};

export const togglePaymentMethodDetailsModal = (show, paymentMethod) => {
  return {
    type: actionTypes.TOGGLE_PAYMENT_METHOD_DETAILS_MODAL,
    data: {
      show,
      paymentMethod,
    },
  };
};



// WEBPACK FOOTER //
// ./src/app/main/payment-methods/actions/payment-method-actions.js